module.exports = __webpack_public_path__ + "static/media/success.f0bcd4b7.svg";